import { TrashIcon } from '@navikt/aksel-icons';
import { Button } from '@digdir/designsystemet-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDeleteSoknad } from '../../building/tabs/useDeleteSoknad';
import { ConfirmDialog } from '../../../components/confirmDialog';

export const DeleteEnergiplanButton = ({ soknadId, buildingId }: { soknadId?: string; buildingId?: string }) => {
  const navigate = useNavigate();
  const { deleteSoknad, isLoading } = useDeleteSoknad(buildingId);
  const { t } = useTranslation();
  const [isConfirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const handleDeleteSoknad = () => {
    deleteSoknad(soknadId, {
      onSuccess: () => {
        navigate(`../bygg/${buildingId}/energiplan`);
      }
    });
  };

  return (
    <>
      <Button
        style={{ alignSelf: 'flex-end' }}
        variant="tertiary"
        onClick={() => setConfirmDialogOpen(true)}
        disabled={isLoading}
      >
        <TrashIcon /> {t('screens.energiplan.index.deleteButton')}
      </Button>
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onConfirm={handleDeleteSoknad}
        onCancel={() => setConfirmDialogOpen(false)}
        title={t('screens.energiplan.index.deleteDialogTitle')}
        content={t('screens.energiplan.index.deleteDialogContent')}
        isLoading={isLoading}
      />
    </>
  );
};
